// ===============================
// Tranzila Integration Utilities
// ===============================

export interface TranzilaPaymentData {
  sum: number
  // Customer details (optional but recommended)
  contact?: string
  email?: string
  phone?: string

  // Product / description
  pdesc?: string

  // Redirects (keep for Meta Pixel + attribution)
  success_url?: string
  fail_url?: string

  // Custom fields (optional)
  u1?: string
  u2?: string
  u3?: string
}

// ===============================
// Tranzila Static Configuration
// ===============================

export const TRANZILA_CONFIG = {
  terminal: 'enerchistore', // ✅ EXACT terminal name (string, not number)
  currency: 1, // 1 = ILS
  tranmode: 'A', // A = standard charge
  credType: 8, // 8 = installments
  maxpay: 3, // up to 3 installments

  // Wallets
  apple_pay: 1,
  google_pay: 1,
  bit_pay: 1,
}

// ===============================
// Early Bird Helpers (unchanged)
// ===============================

export function getEarlyBirdPrice(): number {
  const now = new Date()
  const earlyBirdDeadline = new Date('2026-01-31T23:59:59')
  return now <= earlyBirdDeadline ? 380 : 440
}

export function getEarlyBirdStatus(): {
  isEarlyBird: boolean
  price: number
  deadline: string
} {
  const now = new Date()
  const earlyBirdDeadline = new Date('2026-01-31T23:59:59')
  const isEarlyBird = now <= earlyBirdDeadline

  return {
    isEarlyBird,
    price: isEarlyBird ? 380 : 440,
    deadline: '31/1/2026',
  }
}

// ===============================
// Main Payment Function
// ===============================

export function openTranzilaPayment(data: TranzilaPaymentData): void {
  // Create a hidden form that submits to Tranzila
  const form = document.createElement('form')
  form.method = 'POST'

  // ✅ CORRECT endpoint (NEW DirectNG iframe)
  form.action = `https://directng.tranzila.com/${TRANZILA_CONFIG.terminal}/iframenew.php`

  // ✅ Submit to iframe named 'tranzila' instead of _self
  form.target = 'tranzila'

  // ===============================
  // Tranzila Required + Optional Fields
  // ===============================

  const fields: Record<string, string> = {
    // Payment
    sum: data.sum.toString(),
    currency: TRANZILA_CONFIG.currency.toString(),
    tranmode: TRANZILA_CONFIG.tranmode,
    cred_type: TRANZILA_CONFIG.credType.toString(),
    maxpay: TRANZILA_CONFIG.maxpay.toString(),

    // Wallets
    apple_pay: '1',
    google_pay: '1',
    bit_pay: '1',

    // UI
    lang: 'il',
    nologo: '1',
    buttonLabel: 'לתשלום',

    // Customer (recommended)
    contact: data.contact || '',
    email: data.email || '',
    phone: data.phone || '',

    // Product
    pdesc: data.pdesc || 'Water Tribe Fest 2026',

    // Redirects (IMPORTANT: correct parameter names)
    success_url_address:
      data.success_url || `${window.location.origin}/thank-you`,
    fail_url_address: data.fail_url || window.location.href,
  }

  // Optional custom fields
  if (data.u1) fields.u1 = data.u1
  if (data.u2) fields.u2 = data.u2
  if (data.u3) fields.u3 = data.u3

  // ===============================
  // Build hidden inputs
  // ===============================

  Object.entries(fields).forEach(([key, value]) => {
    if (!value) return
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = value
    form.appendChild(input)
  })

  // ===============================
  // Submit form
  // ===============================

  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}
